import { useLazyQuery, useQuery, gql } from "@apollo/client"

const KNOWLEDGE_FIELDS = `
    id
    title
    category { id name }
    groups { id }
    locations { id }
    content { 
      id
      type
      heading
      values
      value
      uploads { id key fileName fileGroup fileSize }
    }
    author { id firstName lastName avatar { key } }
    createdAt
    updatedAt
`

const KNOWLEDGES_QUERY = gql`
  query Knowledges($filter: KnowledgeFilterInput) {
    knowledges: knowledgesV2(filter: $filter) {
      ${KNOWLEDGE_FIELDS}
    } 
  }
`

const KNOWLEDGE_QUERY = gql`
  query Knowledge($id: ID!) {
    knowledge(id: $id) {
      ${KNOWLEDGE_FIELDS}
    } 
  }
`

const KNOWLEDGE_CREATED_SUBSCRIPTION = gql`
  subscription 
    knowledgeCreated {
      knowledgeCreated {
        ${KNOWLEDGE_FIELDS}
      }
    }
`
const KNOWLEDGE_UPDATED_SUBSCRIPTION = gql`
  subscription 
    knowledgeUpdated {
      knowledgeUpdated {
        ${KNOWLEDGE_FIELDS}
      }
    }
`

const subscribe = (result) => () =>
  [
    result.subscribeToMore({
      document: KNOWLEDGE_CREATED_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev
        const newItem = subscriptionData.data.knowledgeCreated

        // skip if already exists
        if (prev.knowledges.some((p) => p.id === newItem.id)) return prev

        return { ...prev, knowledges: [newItem, ...prev.knowledges] }
      },
      onError: (err) => console.log("[useQueryKnowledges][KNOWLEDGE_CREATED_SUBSCRIPTION(1)]", err),
    }),
    result.subscribeToMore({
      document: KNOWLEDGE_UPDATED_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev
        const updatedItem = subscriptionData.data.knowledgeUpdated
        let knowledge = prev.knowledges.find((p) => p.id === updatedItem.id)
        if (knowledge) {
          knowledge = { ...updatedItem }
        }
        return prev
      },
      onError: (err) => console.log("[useQueryKnowledges][KNOWLEDGE_UPDATED_SUBSCRIPTION]", err),
    }),
  ]

const subscribeSingle = (result) => () =>
  [
    result.subscribeToMore({
      document: KNOWLEDGE_UPDATED_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev
        const updatedItem = subscriptionData.data.knowledgeUpdated
        if (updatedItem.id === prev.knowledge.id) {
          prev.knowledge = { ...updatedItem }
        }
        return prev
      },
      onError: (err) => console.log("[useQueryKnowledges][KNOWLEDGE_CREATED_SUBSCRIPTION(2)]", err),
    }),
  ]

const useQueryKnowledges = (options) => {
  const result = useQuery(KNOWLEDGES_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

  return {
    ...result,
    subscribe: subscribe(result),
  }
}

const useQueryKnowledge = (options) => {
  const result = useQuery(KNOWLEDGE_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

  return {
    ...result,
    subscribe: subscribeSingle(result),
  }
}

const useLazyQueryKnowledge = () => useLazyQuery(KNOWLEDGE_QUERY)

export { useQueryKnowledges, useQueryKnowledge, useLazyQueryKnowledge, KNOWLEDGE_FIELDS, KNOWLEDGES_QUERY }
